import { render, staticRenderFns } from "./FromPriceButton.vue?vue&type=template&id=65f65928&scoped=true"
import script from "./FromPriceButton.vue?vue&type=script&lang=js"
export * from "./FromPriceButton.vue?vue&type=script&lang=js"
import style0 from "./FromPriceButton.vue?vue&type=style&index=0&id=65f65928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f65928",
  null
  
)

export default component.exports